module.exports = __webpack_public_path__ + "b33ce8a7ed3ba7b3471bae81b14d699d.svg";